export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_5.a376e5e7.png";